import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Paper,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'

import useStyles from './styles'

const ActivationCard = ({
  title,
  description,
  label,
  disabled,
  controlName,
  detailsControlName,
  id,
}) => {
  const classes = useStyles()

  const { control, errors, watch } = useFormContext()

  const itemValue = watch(controlName)

  return (
    <Paper className={classes.paper} id={id}>
      <Typography color="primary" variant="subtitle1">
        {title}
      </Typography>
      <Controller
        as={
          <FormControl disabled={disabled}>
            <FormControlLabel
              control={<Switch defaultChecked={itemValue} value={itemValue} />}
              label={label}
            />
            {!!errors?.[controlName] && (
              <FormHelperText error={!!errors?.[controlName]}>
                {errors?.[controlName]?.message}
              </FormHelperText>
            )}
          </FormControl>
        }
        control={control}
        name={controlName}
        onChange={([event]) => event.target.checked}
      />
      {itemValue && detailsControlName && (
        <Controller
          as={
            <TextField
              className={classes.inputDays}
              type="number"
              color="primary"
              variant="outlined"
              disabled={disabled}
              label="Selecione a quantidade de dias"
              error={!!errors?.[detailsControlName]}
              helperText={errors?.[detailsControlName]?.message}
            />
          }
          control={control}
          mode="onChange"
          name={detailsControlName}
          onChange={([event]) => event.target.value.slice(0, 1)}
        />
      )}
      <Typography>{description}</Typography>
    </Paper>
  )
}

ActivationCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  controlName: PropTypes.string.isRequired,
  detailsControlName: PropTypes.string,
  id: PropTypes.string,
}

export default ActivationCard
